import { useEffect, useRef, useState, type RefObject } from 'react'

// Читаем один раз на модуль: смена настройки посреди сессии — редкий случай,
// ради него не стоит держать подписку в каждой секции.
const prefersReducedMotion =
  typeof window !== 'undefined' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useInView(
  threshold = 0.15,
  rootMargin = '0px 0px -80px 0px',
): { ref: RefObject<any>; inView: boolean } {
  const ref = useRef<HTMLElement>(null)
  // Появление по скроллу — это тоже движение, поэтому при «уменьшить движение»
  // секции сразу считаются видимыми и observer не заводится вовсе.
  // Дело не только во вкусе: с reduced motion скролл мгновенный, и прыжок по
  // якорю из хедера перескакивает секции — они не попадают в observer ни на
  // одном кадре и остались бы скрытыми до ручного возврата к ним.
  const [inView, setInView] = useState(prefersReducedMotion)

  useEffect(() => {
    if (prefersReducedMotion) return
    const el = ref.current
    if (!el) return
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true)
          observer.disconnect()
        }
      },
      { threshold, rootMargin }
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [threshold, rootMargin])

  return { ref, inView }
}
